import useFetchData from "../../utils/hooks/useFetchData";
import { PrioritiesIncidents } from "../Widgets/PrioritiesIncidents";
import { SimpleAreaWidget } from "../Widgets/SimpleAreaWidget";
import Spinner from "../Global/Spinner";
import { HrHorizontal } from "../Global/HrHorizontal";
import { Card } from "antd";
import { GaugeChartWidget } from "../Widgets/GaugeChartWidget";
import { AreaAndScatterWidget } from "../Widgets/AreaAndScatterWidget";

const CardWidgetStyle = {
    width: '33%',
    display: 'flex',
    justifyContent: 'center',
    height: '100%',
    padding: '5px',
    flexDirection: 'column'
};

const verticalLineStyle = {
    width: '1px', // Espessura da linha
    backgroundColor: 'black', // Cor da linha
    margin: '0 10px', // Espaçamento horizontal ao redor da linha
};

export const Enviorment = () => {
    const { data: enviormentData } = useFetchData('/nova_wallboards/getenviormentdata');

    if (enviormentData) {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                <div style={{ width: '100%', display: 'flex', height: '15%' }}>
                    <Card.Grid style={{ width: '100%', alignSelf: 'center', padding: '5px' }}>
                        <PrioritiesIncidents data={enviormentData?.events} />
                    </Card.Grid>
                    {/* <HrHorizontal /> */}
                    <div style={verticalLineStyle}></div>
                    <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '5px' }}>
                        <GaugeChartWidget label="UV INDEX"
                            // reverse={true}
                            value={enviormentData?.actualUVIndex ?? 0}
                            unit="uv"
                            margin='0'
                            colors={["#9dc600", "#ffbd02", "#ff9001", "#f65024", "#9e46cd"]}
                            nrOfLevels={5}
                            arcsLength={[2, 5, 2, 3, 1]} />
                    </Card.Grid>
                </div>
                <HrHorizontal width='95%' />
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '27%' }}>
                    <span style={{ alignSelf: 'center', fontWeight: 'bold', color: '#659767', margin: '2px 0 0 0', fontSize: 'x-large' }}>DADOS ATMOSFÉRICOS</span>
                    <div style={{ display: 'flex', height: '90%' }}>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekTemperature?.average}</span>
                            <SimpleAreaWidget
                                label="TEMPERATURA"
                                data={enviormentData?.weekTemperature?.metrics}
                                marginTop='5px'
                                height='100%'
                                name='temperatura' />
                        </Card.Grid>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekCO2Emissions?.average}</span>
                            <SimpleAreaWidget
                                label="EMISSÕES CO2"
                                data={enviormentData?.weekCO2Emissions?.metrics}
                                marginTop='5px'
                                height='100%'
                                domain={['dataMin', 'dataMax + 5']}
                                name='ppm' />
                        </Card.Grid>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekHumidityLevel?.average}</span>
                            <SimpleAreaWidget
                                label="HUMIDADE DE AR"
                                data={enviormentData?.weekHumidityLevel?.metrics}
                                marginTop='5px'
                                height='100%'
                                name='%' />
                        </Card.Grid>
                    </div>
                </div>
                <HrHorizontal width='95%' />
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '27%' }}>
                    <span style={{ alignSelf: 'center', fontWeight: 'bold', color: '#659767', margin: '2px 0 0 0', fontSize: 'x-large' }}>RUÍDO</span>
                    <Card.Grid style={{ width: '100%', display: 'flex', justifyContent: 'center', height: '100%', padding: '5px', flexDirection: 'column' }}>
                        <span style={{ alignSelf: 'center' }}>{enviormentData?.weekSoundLevel?.average}</span>
                        <AreaAndScatterWidget
                            label="NÍVEL SONORO MÉDIO"
                            data={enviormentData?.weekSoundLevel?.metrics}
                            marginTop='5px'
                            height='100%'
                            name='dB'
                            nameScatter='max dB' />
                    </Card.Grid>
                </div>
                <HrHorizontal width='95%' />
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', height: '27%' }}>
                    <span style={{ alignSelf: 'center', fontWeight: 'bold', color: '#659767', margin: '2px 0 0 0', fontSize: 'x-large' }}>SOLO</span>
                    <div style={{ display: 'flex', height: '90%' }}>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekGroundTemperature?.average}</span>
                            <SimpleAreaWidget
                                label="TEMPERATURA DO SOLO"
                                data={enviormentData?.weekGroundTemperature?.metrics}
                                marginTop='5px'
                                height='100%'
                                name='temperatura' />
                        </Card.Grid>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekGroundElectricalConductivity?.average}</span>
                            <SimpleAreaWidget
                                label="CONDUTIVIDADE ELÉTRICA DO SOLO"
                                data={enviormentData?.weekGroundElectricalConductivity?.metrics}
                                marginTop='5px'
                                height='100%'
                                name='dS/m' />
                        </Card.Grid>
                        <Card.Grid style={CardWidgetStyle}>
                            <span style={{ alignSelf: 'center' }}>{enviormentData?.weekGroundHumidity?.average}</span>
                            <SimpleAreaWidget
                                label="HUMIDADE DO SOLO"
                                data={enviormentData?.weekGroundHumidity?.metrics}
                                marginTop='5px'
                                height='100%'
                                name='%' />
                        </Card.Grid>
                    </div>
                </div>
                {/* <div style={{ height: '4%', alignSelf: 'flex-start', fontSize: 'small', fontWeight: 'bold', alignContent: 'end', marginLeft: '10px'}}>
                <span style={{color: 'black'}}>Dados de Domingo a Sábado</span>
            </div> */}
            </div>
        );
    } else {
        return (
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Spinner />
            </div>
        );
    }
};